import { render, staticRenderFns } from "./CustomersOrdered.vue?vue&type=template&id=2f74229d"
import script from "./CustomersOrdered.vue?vue&type=script&lang=js"
export * from "./CustomersOrdered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports